module.exports = __webpack_public_path__ + "img/UserBox.66349dec.svg";